import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CognitoAuthService } from './services/cognito-auth.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  pvfTopUrl = environment.pvfTopUrl;
  isAboutModalOpen = false;
  isContactModalOpen = false;
  currentRoute: string = '';
  isAuthenticated$: Observable<boolean>;
  userData$: Observable<any>;
  showUserDropdown = false;

  constructor(
    private router: Router,
    private cognitoAuth: CognitoAuthService
  ) {
    this.isAuthenticated$ = this.cognitoAuth.isAuthenticated$;
    this.userData$ = this.cognitoAuth.userData$;
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.currentRoute = event.url;
    });
  }

  /**
   * メニューのドロップダウン切り替え
   */
  toggleDropdown(event: Event) {
    event.preventDefault();
    const dropdownMenu = (event.target as HTMLElement).nextElementSibling as HTMLElement;

    const allDropdowns = document.querySelectorAll('.dropdown-menu');
    allDropdowns.forEach(dropdown => {
      if (dropdown !== dropdownMenu) {
        (dropdown as HTMLElement).style.display = 'none';
      }
    });

    if (dropdownMenu) {
      dropdownMenu.style.display = dropdownMenu.style.display === 'block' ? 'none' : 'block';
    }
  }

  /**
   * ユーザードロップダウンの切り替え
   */
  toggleUserDropdown() {
    this.showUserDropdown = !this.showUserDropdown;
  }

  /**
   * ログイン処理（Cognito Hosted UI へリダイレクト）
   */
  onLogin() {
    this.cognitoAuth.login();
  }

  /**
   * ログアウト処理（Cognito からサインアウト）
   */
  onLogout() {
    this.showUserDropdown = false;
    this.cognitoAuth.logout();
  }

  /**
   * 画面外クリックでドロップダウンを閉じる
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-menu')) {
      this.showUserDropdown = false;
    }
  }
}
